<script>
    import Panel from "./content-panel/Panel.svelte";
    import { onMount, onDestroy } from 'svelte';
    import SvelteTooltip from "svelte-tooltip";
    import IosToggle from "./IosToggle.svelte";
    import SubscribersFilterPanel from "./content-panel/SubscribersFilterPanel.svelte";
    import CommentsFilterPanel from "./content-panel/CommentsFilterPanel.svelte";
    import SpamMarksFilterPanel from "./content-panel/SpamMarksFilterPanel.svelte";
    import DirectRequestsFilterPanel from "./content-panel/DirectRequestsFilterPanel.svelte";
    import { t, locale, locales } from "../../scripts/i18n";
    import CreateBackupPanel from "./content-panel/CreateBackupPanel.svelte";

    onMount(() => {
        window.scrollTo(0, 0);
    });

    export let params = {};
    let divHeight;

    let guardIsActive = true;
    $: params && params.stage && (guardIsActive = params.stage.guard.isActive);

    let selectedCategory = 'subscribers';
    let filterSubscribers = (params && params.stage) ? params.stage.guard.filterSubscribers : true;
    //$: params && params.stage && (filterSubscribers = params.stage.guard.filterSubscribers);
    $: (filterSubscribers || !filterSubscribers) && updateState();
    let filterComments = (params && params.stage) ? params.stage.guard.filterComments : true;
    //$: params && params.stage && (filterComments = params.stage.guard.filterComments);
    $: (filterComments || !filterComments) && updateState();
    let filterSpamMarks = (params && params.stage) ? params.stage.guard.filterSpamMarks : true;
    //$: params && params.stage && (filterSpamMarks = params.stage.guard.filterSpamMarks);
    $: (filterSpamMarks || !filterSpamMarks) && updateState();
    let filterDirectRequests = (params && params.stage) ? params.stage.guard.filterDirectRequests : true;
    //$: params && params.stage && (filterDirectRequests = params.stage.guard.filterDirectRequests);
    $: (filterDirectRequests || !filterDirectRequests) && updateState();
    let createBackup = (params && params.stage) ? params.stage.guard.createBackup : true;
    $: (createBackup || !createBackup) && updateState();

    function updateState() {
        params.setStage({
            guard: {
                isActive: guardIsActive,
                filterSubscribers: filterSubscribers,
                filterComments: filterComments,
                filterSpamMarks: filterSpamMarks,
                filterDirectRequests: filterDirectRequests,
                createBackup: createBackup,
            }
        });
    }

    function toggleProtection() {
        return;
        guardIsActive = !guardIsActive;
        if (guardIsActive) {
            filterSubscribers = true;
            filterComments = true;
            filterSpamMarks = true;
            filterDirectRequests = true;
        } else {
            filterSubscribers = false;
            filterComments = false;
            filterSpamMarks = false;
            filterDirectRequests = false;
        }
        params.setStage({
            guard: {
                isActive: guardIsActive,
                filterSubscribers: filterSubscribers,
                filterComments: filterComments,
                filterSpamMarks: filterSpamMarks,
                filterDirectRequests: filterDirectRequests,
            }
        });
    }


</script>

<div class="analyze-in-progress-wrap position-relative" style={`min-height: ${divHeight}px;`}>
    <div class="banner-top">

    </div>

    <div class="inner-content-wrap position-absolute top-0 w-100pc" bind:clientHeight={divHeight}>
        <Panel>
            <span slot="icon">
                <img src="/static/media/mdi_shield-refresh-outline.2304e7cb.svg" alt="/" class="scan-block_top-img mr-5px">
            </span>
            <span slot="title">{$t('Real-time protection')}</span>
            <div slot="content">
                {#if guardIsActive}
                    <div class="scan-block_content-step_top">
                        <p class="scan-block_content-step-title">
                            {$t('Account protection is active. To stop Protection, click on the button')}
                        </p>
                        <a href="#" type="button" on:click={toggleProtection} class="white-btn white-btn_hover w-210px h-45px">{$t('Stop')}</a>
                    </div>
                {:else}
                    <div class="scan-block_content-step_top">
                        <p class="scan-block_content-step-title">
                            {$t('To start Account Protection, click the button.')}
                        </p>
                        <a href="#" type="button" on:click={toggleProtection} class="purple-btn purple-btn_hover w-210px h-45px">{$t('Protect')}</a>
                    </div>
                {/if}

                <div class="inner-panel-wrap setup-panel-wrap">
                    <div class="panel-columns-wrap mb-20px">
                        <div class="categories-wrap">
                            <div class="header-wrap mb-20px title-mb">
                                <div class="title-wrap mb-10px">{$t('Account protection categories')}</div>
                                <div class="description-wrap">
                                    {$t('Click on any category to view and change settings. If the toggle switch opposite any category is turned on, then all types of included threats will be deleted after starting Protection')}
                                </div>
                            </div>

                            <div class="categories-list">
                                <a class={`category-wrap ${selectedCategory === 'subscribers' ? 'active' : ''}`} on:click={() => {selectedCategory = 'subscribers'}}>
                                    <div class="tooltip-wrap">
                                        <SvelteTooltip tip="{$t('The Subscribers who fit some of the selected categories of undesirable accounts will be automatically deleted in real time.')}" top >
                                            <img src="/static/media/ant-design_question-circle-filled.e4dc2b6a.svg" class="tooltip-img" />
                                        </SvelteTooltip>
                                    </div>
                                    <div class="title-wrap">
                                        {$t('Filter unwanted followers')}
                                    </div>
                                    <div class="toggler-wrap">
                                        <IosToggle
                                                label=""
                                                bind:checked={filterSubscribers}
                                                disabled={!guardIsActive}
                                                showTooltip={false}
                                                tooltipTitle={null}
                                                tooltipContent=""
                                                backgroundColor="#8001BD"
                                                widgetClass="w-100pc"
                                        />
                                    </div>
                                </a>

                            </div>

                            <div class="categories-list">
                                <a class={`category-wrap ${selectedCategory === 'comments' ? 'active' : ''}`} on:click={() => {selectedCategory = 'comments'}}>
                                    <div class="tooltip-wrap">
                                        <SvelteTooltip tip="{$t('New comments which include the specified unwanted stop words will be automatically deleted in real time')}" top >
                                            <img src="/static/media/ant-design_question-circle-filled.e4dc2b6a.svg" class="tooltip-img" />
                                        </SvelteTooltip>
                                    </div>
                                    <div class="title-wrap">
                                        {$t('Filter unwanted comments')}
                                    </div>
                                    <div class="toggler-wrap">
                                        <IosToggle
                                                label=""
                                                bind:checked={filterComments}
                                                disabled={!guardIsActive}
                                                showTooltip={false}
                                                tooltipTitle={null}
                                                tooltipContent=""
                                                backgroundColor="#8001BD"
                                                widgetClass="w-100pc"
                                        />
                                    </div>
                                </a>

                            </div>

                            <div class="categories-list">
                                <a class={`category-wrap ${selectedCategory === 'spam-marks' ? 'active' : ''}`} on:click={() => {selectedCategory = 'spam-marks'}}>
                                    <div class="tooltip-wrap">
                                        <SvelteTooltip tip="{$t('The marks on a photo will be automatically deleted in real time if their authors fit certain categories of undesirable accounts.')}" top >
                                            <img src="/static/media/ant-design_question-circle-filled.e4dc2b6a.svg" class="tooltip-img" />
                                        </SvelteTooltip>
                                    </div>
                                    <div class="title-wrap">
                                        {$t('Filter marks on spam publications')}
                                    </div>
                                    <div class="toggler-wrap">
                                        <IosToggle
                                                label=""
                                                bind:checked={filterSpamMarks}
                                                disabled={!guardIsActive}
                                                showTooltip={false}
                                                tooltipTitle={null}
                                                tooltipContent=""
                                                backgroundColor="#8001BD"
                                                widgetClass="w-100pc"
                                        />
                                    </div>
                                </a>

                            </div>

                            <div class="categories-list">
                                <a class={`category-wrap ${selectedCategory === 'direct-requests' ? 'active' : ''}`} on:click={() => {selectedCategory = 'direct-requests'}}>
                                    <div class="tooltip-wrap">
                                        <SvelteTooltip tip="{$t('Direct requests whose senders match the selected categories of undesirable accounts will be automatically deleted in real time.')}" top >
                                            <img src="/static/media/ant-design_question-circle-filled.e4dc2b6a.svg" class="tooltip-img" />
                                        </SvelteTooltip>
                                    </div>
                                    <div class="title-wrap">
                                        {$t('Filter unwanted requests to the Direct')}
                                    </div>
                                    <div class="toggler-wrap">
                                        <IosToggle
                                                label=""
                                                bind:checked={filterDirectRequests}
                                                disabled={!guardIsActive}
                                                showTooltip={false}
                                                tooltipTitle={null}
                                                tooltipContent=""
                                                backgroundColor="#8001BD"
                                                widgetClass="w-100pc"
                                        />
                                    </div>
                                </a>

                            </div>
                            {#if (window.language === 'ru-RU')}
                                <div class="categories-list">
                                    <a class={`category-wrap ${selectedCategory === 'create-backup' ? 'active' : ''}`} on:click={() => {selectedCategory = 'create-backup'}}>
                                        <div class="tooltip-wrap">
                                            <SvelteTooltip tip="С помощью данной опции, вы можете создавать резервную копию вашей аудитории и контента раз в месяц." top >
                                                <img src="/static/media/ant-design_question-circle-filled.e4dc2b6a.svg" class="tooltip-img" />
                                            </SvelteTooltip>
                                        </div>
                                        <div class="title-wrap">
                                            Создавать резервную копию всех данных
                                        </div>
                                        <div class="toggler-wrap">
                                            <IosToggle
                                                    label=""
                                                    bind:checked={createBackup}
                                                    disabled={!guardIsActive}
                                                    showTooltip={false}
                                                    tooltipTitle={null}
                                                    tooltipContent=""
                                                    backgroundColor="#8001BD"
                                                    widgetClass="w-100pc"
                                            />
                                        </div>
                                    </a>

                                </div>
                            {/if}

                        </div>
                        <div class="settings-wrap">
                            <div class="header-wrap mb-20px">
                                <div class="description-wrap pb-25px">
                                    {#if (selectedCategory === 'create-backup')}
                                        Выберите параметры резервного копирования
                                    {:else}
                                        {$t('Choose all required parameters of threats that the service will filter and remove in real time')}
                                    {/if}
                                </div>

                            </div>

                            <div class="ml-10px panel-inner-wrap">
                                {#if selectedCategory === 'subscribers'}
                                    <SubscribersFilterPanel />
                                {:else if selectedCategory === 'comments'}
                                    <CommentsFilterPanel />
                                {:else if selectedCategory === 'spam-marks'}
                                    <SpamMarksFilterPanel />
                                {:else if selectedCategory === 'direct-requests'}
                                    <DirectRequestsFilterPanel />
                                {:else if selectedCategory === 'create-backup'}
                                    <CreateBackupPanel />
                                {/if}
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </Panel>
    </div>
</div>

<style>
    @media (max-device-width: 480px) {
        .panel-columns-wrap {
            flex-direction: column;
        }
        .title-mb {
            margin-bottom: 100px !important;
        }
        .scan-block_content-step-title {
            width: 100%;
        }
    }

    @media (min-device-width: 481px) {
        .panel-columns-wrap {
            flex-direction: row;
        }
        .panel-columns-wrap > div {
            width: 50%;
        }
    }

    .panel-columns-wrap {
        display: flex;
        justify-content: center;
        align-items: normal;
    }

    .scan-block_content-step_top {
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .setup-panel-wrap {
        background: #fff;
        border: 0.5px solid #8a8585;
        box-sizing: border-box;
        box-shadow: 0 4px 10px rgba(0,0,0,.25);
        border-radius: 21px;
        padding: 20px;
        margin-top: 20px;
        margin-bottom: 20px;
        text-align: center;
        min-height: 388px;
    }
    .setup-panel-wrap .header-wrap {
        height: 85px;
    }
    .setup-panel-wrap .header-wrap .title-wrap {
        font-family: Roboto;
        font-style: normal;
        text-align: center;
        font-weight: 400;
        font-size: 20px;
        line-height: 23px;
    }
    .setup-panel-wrap .header-wrap .description-wrap {
        min-height: 75px;
        font-weight: 300;
        font-size: 14px;
        line-height: 16px;
        padding: 0 10px;
    }



    .category-wrap {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #000;
        text-decoration: none;
        padding: 5px;
    }
    .category-wrap:hover {
        color: #000;
        text-decoration: none;
        background-color: rgba(148,0,211,.15);
    }
    .category-wrap.active {
        background-color: rgba(148,0,211,.15);
    }
    .category-wrap .title-wrap {
        flex-grow: 1;
    }
    .category-wrap .toggler-wrap {
        width: 50px;
    }
    .category-wrap .counter-wrap {
        width: 50px;
        text-align: right;
        font-weight: 700;
        font-size: 16px;
        margin-right: 10px;
    }
    .category-wrap .tooltip-wrap {
        width: 50px;
    }
    .category-wrap .title-wrap {
        font-family: Roboto;
        font-style: normal;
        color: #000;
        text-align: left;
        font-weight: 300;
        font-size: 14px;
    }
    .pb-25px {
        padding-top: 32px !important;
    }
</style>